import { CalendarDays } from "lucide-react";

interface LastUpdatedProps {
  date: string; // ISO date string
  className?: string;
}

const LastUpdated = ({ date, className = "" }: LastUpdatedProps) => {
  const formatted = new Date(date).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <p className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className}`}>
      <CalendarDays className="w-3.5 h-3.5 shrink-0" />
      Mis à jour le : <time dateTime={date}>{formatted}</time>
    </p>
  );
};

export default LastUpdated;
